import React, { useEffect, useState } from 'react';
import { Table } from 'semantic-ui-react';

import './HmdEventsTable.css';

export default function HmdEventsTable(props) {
  const { webSocketService } = props || {};
  const [state, setState] = useState((webSocketService || {}).state);
  useEffect(() => {
    if (webSocketService) {
      webSocketService.setState = setState;
    }
    return () => { // cleanup
      if (webSocketService) {
        webSocketService.setState = () => {
        };
      }
    };
  }, [webSocketService]);
  const {
    hmdEventData = [],
  } = state || {};

  return (
    <div className="hmd-events-table">
      {hmdEventData.length > 0
        ? (
          <Table celled padded>
            <Table.Header colSpan="3" id="header">
              <Table.Row>
                <Table.HeaderCell>Thing Name</Table.HeaderCell>
                <Table.HeaderCell>Timestamp</Table.HeaderCell>
                <Table.HeaderCell>Action</Table.HeaderCell>
                <Table.HeaderCell>Display</Table.HeaderCell>
                <Table.HeaderCell>Line 1 Text</Table.HeaderCell>
                <Table.HeaderCell>Line 2 Text</Table.HeaderCell>
                <Table.HeaderCell>Line 3 Text</Table.HeaderCell>
                <Table.HeaderCell>Client Origin</Table.HeaderCell>
                <Table.HeaderCell>Max Met Rate</Table.HeaderCell>
                <Table.HeaderCell>Max State List Length</Table.HeaderCell>
                <Table.HeaderCell>Screen Rotation</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {
                hmdEventData.reverse()
                  .map((event) => (
                    <Table.Row key={`hmd-event-data-${event.timestamp}`}>
                      <Table.Cell>{event.thingName}</Table.Cell>
                      <Table.Cell>{event.timestamp}</Table.Cell>
                      <Table.Cell>{event.action ? event.action : ''}</Table.Cell>
                      <Table.Cell>{event.display ? event.display : ''}</Table.Cell>
                      <Table.Cell>{event.line1Text ? event.line1Text : ''}</Table.Cell>
                      <Table.Cell>{event.line2Text ? event.line2Text : ''}</Table.Cell>
                      <Table.Cell>{event.line3Text ? event.line3Text : ''}</Table.Cell>
                      <Table.Cell>{event.clientOrigin ? event.clientOrigin : ''}</Table.Cell>
                      <Table.Cell>{event.maxMetRate ? event.maxMetRate : ''}</Table.Cell>
                      <Table.Cell>{event.maxStateListLength ? event.maxStateListLength : ''}</Table.Cell>
                      <Table.Cell>{event.screenRotation ? event.screenRotation : ''}</Table.Cell>
                    </Table.Row>
                  ))
              }
            </Table.Body>
          </Table>
        ) : 'No HMD event data yet, send a command - HMD Events only show reported state. HMD must be online to update.'}
    </div>
  );
}
